module.exports = __webpack_public_path__ + "static/media/web_certificate.2b5eb253.gif";